import React, { useState, useEffect, useRef, useMemo } from "react";
import { Box, TextField } from "@mui/material";
import {
  getSPCReportTableDetails,
  getAnalyticsIChartDetail,
  getAnalyticsMRChartDetail,
} from "../services";
import dayjs from "dayjs";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";

import Switch from "@mui/material/Switch";
import { useDispatch, useSelector } from "react-redux";
import { setSmartTagReportData } from "../MachineDashboard/Slice";
import SPCSelectedTagGraphData from "../MachineDashboard/GraphmachineDashboard/SPCSelectedTagGraphData";

const SPCGraphComponent = ({
  activeTabClass,
  COCIntervalTime,
  POPIntervalTimePop,
  LineGraphData,
  Graphdata,
  tagID,
  tagSelectPOP,
  averageArray,
  averagePOP,
  BarGraphData1,
  BarGraphData2,
  VmsReportSelectmachine,
  VmsReportSelectmachine1,
  LineChartdata,
  LineChartdata2,
  isShimmerCOC,
  isShimmerLineChartCOC,
  isShimmerPOP,
  isShimmerLineChartPOP,
  setLineCOCIntervalTime,
  setLinePOPIntervalTime,
  LineCOCIntervalTime,
  LinePOPIntervalTime,
  smartTagCOCSwitch,
  smartTagPOPSwitch,
  disableOtherUnits,
  disableOtherUnitsPOP,
  piechartData,
  pieChartSum,
  piechartDataPOP,
  piechartDataPOP1,
  aggCOC,
  aggPOP,
  // Optional props for SPC control limits
  spcUcl,
  spcCl,
  spcLcl,
  spcTagUnit,
  // Analytics I Chart and MR Chart data
  analyticsIChartData,
  analyticsMRChartData,
  analyticsIChartUcl,
  analyticsIChartCl,
  analyticsIChartLcl,
  analyticsMRChartUcl,
  analyticsMRChartCl,
  analyticsMRChartLcl,
  analyticsTagName,
  analyticsTagColor,
  // Separate intervals for I Chart and MR Chart
  analyticsIChartInterval,
  analyticsMRChartInterval,
  setAnalyticsIChartInterval,
  setAnalyticsMRChartInterval,
  // Reports mode props
  formatStartDatePOP,
  formatEndDatePOP,
  formatStartTimePOP,
  formatEndTimePOP,
  smartTagPOPTime,
  rangePOP,
  params,
  selectedReportChartInterval,
  selectedChartType,
  // Callback to call store API when dropdown tags change
  onDropdownTagChange,
  // Stored tag units for left and right dropdowns from getStorePreviousSelectedData
  storedLeftTagUnit,
  storedRightTagUnit,
  // Callback to get chart ref for export
  onChartRefReady,
  // Callbacks to get Analytics chart refs for export
  onAnalyticsIChartRefReady,
  onAnalyticsMRChartRefReady,
}) => {
  // Ref for Reports chart (for export functionality)
  const reportsChartRef = useRef(null);
  // Refs for Analytics charts (for export functionality)
  const analyticsIChartRef = useRef(null);
  const analyticsMRChartRef = useRef(null);

  // Selected tags from reports mode (max 2 tags)
  // CRITICAL FIX: Use useMemo to prevent array recreation on every render
  const reportsSelectedTags = useMemo(
    () => (activeTabClass === "reports" && tagSelectPOP ? tagSelectPOP : []),
    [activeTabClass, tagSelectPOP]
  );

  // State for selected tags in dropdowns (for reports mode)
  const [selectedTag1, setSelectedTag1] = useState("");
  const [selectedTag2, setSelectedTag2] = useState("");

  // Store selected tag details for future use
  const [selectedTagDetails, setSelectedTagDetails] = useState({
    tag1: null,
    tag2: null,
  });

  // State for report table data
  const [reportTableData, setReportTableData] = useState([]);
  const [isLoadingReportTable, setIsLoadingReportTable] = useState(false);

  // State for chart data (for both tags)
  const [chartDataTag1, setChartDataTag1] = useState([]);
  const [chartDataTag2, setChartDataTag2] = useState([]);
  const [chartControlLimitsTag1, setChartControlLimitsTag1] = useState({
    ucl: null,
    cl: null,
    lcl: null,
  });
  const [chartControlLimitsTag2, setChartControlLimitsTag2] = useState({
    ucl: null,
    cl: null,
    lcl: null,
  });
  const [isLoadingChart, setIsLoadingChart] = useState(false);

  // Refs to store initial start dates for polling (for both tags)
  const chartTag1StartDateRef = useRef(null);
  const chartTag2StartDateRef = useRef(null);
  const chartTag1IntervalRef = useRef(null);
  const chartTag2IntervalRef = useRef(null);

  // Get Redux data for auto-selection
  const { SPCTopBarTagData, SPCtagClickebleData } = useSelector(
    (state) => state.smartTagReportSlice
  );

  // Ref to track if auto-selection has been done for reports dropdown
  const hasAutoSelectedDropdownRef = useRef(false);

  // Ref to track previous Redux data to detect changes
  const prevSPCTopBarTagDataForDropdownRef = useRef(null);
  const prevSPCtagClickebleDataForDropdownRef = useRef(null);

  // Auto-select tag in dropdown from Redux data when reports tab loads
  useEffect(() => {
    if (activeTabClass !== "reports" || reportsSelectedTags.length === 0) {
      // Reset ref when switching away from reports or when no tags available
      if (activeTabClass !== "reports") {
        hasAutoSelectedDropdownRef.current = false;
      }
      return;
    }

    // Reset ref when Redux data actually changes (not just on every render)
    const dataChanged =
      prevSPCTopBarTagDataForDropdownRef.current !== SPCTopBarTagData ||
      JSON.stringify(prevSPCtagClickebleDataForDropdownRef.current) !==
        JSON.stringify(SPCtagClickebleData);
    if (dataChanged) {
      hasAutoSelectedDropdownRef.current = false;
      prevSPCTopBarTagDataForDropdownRef.current = SPCTopBarTagData;
      prevSPCtagClickebleDataForDropdownRef.current = SPCtagClickebleData;
    }

    // Only auto-select once when tags become available or when data changes
    if (hasAutoSelectedDropdownRef.current) {
      return;
    }

    // Priority 1: Check if SPCTopBarTagData is available
    let tagIdToSelect = null;
    if (SPCTopBarTagData && SPCTopBarTagData.tag_id) {
      tagIdToSelect = SPCTopBarTagData.tag_id;
    } else if (SPCtagClickebleData?.length && params?.plantid) {
      // Priority 2: Fall back to SPCtagClickebleData
      const spcData = SPCtagClickebleData.find(
        (f) => f.plantId == params.plantid
      );
      if (spcData && spcData.tagId) {
        tagIdToSelect = spcData.tagId;
      }
    }

    // If we have a tag ID to select, find it in the available tags and select it
    if (tagIdToSelect) {
      const matchingTag = reportsSelectedTags.find(
        (tag) => tag.tagId?.toString() === tagIdToSelect?.toString()
      );

      if (matchingTag && !selectedTag1) {
        // Auto-select in first dropdown
        setSelectedTag1(tagIdToSelect.toString());
        setSelectedTagDetails((prev) => ({
          ...prev,
          tag1: matchingTag,
        }));
        hasAutoSelectedDropdownRef.current = true;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeTabClass,
    reportsSelectedTags,
    SPCTopBarTagData,
    SPCtagClickebleData,
    params?.plantid,
  ]);

  // Set dropdown selections from stored previous data (left_tag_unit and right_tag_unit)
  useEffect(() => {
    if (
      activeTabClass !== "reports" ||
      reportsSelectedTags.length === 0 ||
      (!storedLeftTagUnit && !storedRightTagUnit)
    ) {
      return;
    }

    // Set left dropdown from storedLeftTagUnit
    if (storedLeftTagUnit && !selectedTag1) {
      const leftTagId = storedLeftTagUnit.toString();
      const matchingTag = reportsSelectedTags.find(
        (tag) => tag.tagId?.toString() === leftTagId
      );
      if (matchingTag) {
        setSelectedTag1(leftTagId);
        setSelectedTagDetails((prev) => ({
          ...prev,
          tag1: matchingTag,
        }));
      }
    }

    // Set right dropdown from storedRightTagUnit
    if (storedRightTagUnit && !selectedTag2) {
      const rightTagId = storedRightTagUnit.toString();
      const matchingTag = reportsSelectedTags.find(
        (tag) => tag.tagId?.toString() === rightTagId
      );
      if (matchingTag) {
        setSelectedTag2(rightTagId);
        setSelectedTagDetails((prev) => ({
          ...prev,
          tag2: matchingTag,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeTabClass,
    reportsSelectedTags,
    storedLeftTagUnit,
    storedRightTagUnit,
  ]);

  // Clear dropdown selections when tags are deselected (but don't auto-select)
  useEffect(() => {
    if (activeTabClass === "reports") {
      // Only clear dropdowns if selected tags are no longer in the available list
      if (selectedTag1 && reportsSelectedTags.length > 0) {
        const tagStillExists = reportsSelectedTags.some(
          (tag) => tag.tagId?.toString() === selectedTag1
        );
        if (!tagStillExists) {
          setSelectedTag1("");
          setSelectedTagDetails((prev) => ({
            ...prev,
            tag1: null,
          }));
        }
      }
      if (selectedTag2 && reportsSelectedTags.length > 0) {
        const tagStillExists = reportsSelectedTags.some(
          (tag) => tag.tagId?.toString() === selectedTag2
        );
        if (!tagStillExists) {
          setSelectedTag2("");
          setSelectedTagDetails((prev) => ({
            ...prev,
            tag2: null,
          }));
        }
      }
      // Clear both dropdowns if no tags are selected at all
      if (reportsSelectedTags.length === 0) {
        setSelectedTag1("");
        setSelectedTag2("");
        setSelectedTagDetails({ tag1: null, tag2: null });
        hasAutoSelectedDropdownRef.current = false; // Reset when tags are cleared
      }
    } else {
      // Clear dropdowns when switching away from reports tab
      setSelectedTag1("");
      setSelectedTag2("");
      setSelectedTagDetails({ tag1: null, tag2: null });
    }
    // FIXED: Removed selectedTag1 and selectedTag2 from dependencies to prevent infinite loop
    // They are being SET inside this effect, not READ for external logic
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsSelectedTags, activeTabClass]);

  // Function to fetch report table data
  const fetchReportTableData = async (tagIds) => {
    if (!tagIds || tagIds.length === 0) {
      setReportTableData([]);
      return;
    }

    if (!params || !params.plantid) {
      return;
    }

    setIsLoadingReportTable(true);
    try {
      const payload = {
        company_id: params.companyid || 0,
        plant_id: params.plantid,
        tag_ids: tagIds,
      };

      // Add interval if available (use selectedReportChartInterval for reports mode, otherwise use existing logic)
      const currentInterval =
        activeTabClass === "reports" && selectedReportChartInterval
          ? selectedReportChartInterval
          : smartTagPOPSwitch
          ? LinePOPIntervalTime
          : POPIntervalTimePop;
      if (currentInterval) {
        payload.interval = parseInt(currentInterval);
      }

      // Add start_date if available
      if (formatStartDatePOP) {
        let startDateTime = formatStartDatePOP;
        // Check time switch state for Reports mode
        if (activeTabClass === "reports" && !smartTagPOPTime) {
          // Time switch is OFF: use 00:00:00
          startDateTime = `${formatStartDatePOP} 00:00:00`;
        } else if (formatStartTimePOP) {
          // Time switch is ON: use selected time
          startDateTime = `${formatStartDatePOP} ${formatStartTimePOP}`;
        }
        payload.start_date = startDateTime;
      }

      // Add end_date if available
      if (formatEndDatePOP) {
        let endDateTime = formatEndDatePOP;
        // Check time switch state for Reports mode
        if (activeTabClass === "reports" && !smartTagPOPTime) {
          // Time switch is OFF: check if end date is today or past
          const endDateObj = dayjs(formatEndDatePOP);
          const today = dayjs();
          const isToday =
            endDateObj.format("YYYY-MM-DD") === today.format("YYYY-MM-DD");

          if (isToday) {
            // End date is today: use current time
            endDateTime = today.format("YYYY-MM-DD HH:mm:ss");
          } else {
            // End date is past: use 23:59:59
            endDateTime = `${formatEndDatePOP} 23:59:59`;
          }
        } else if (formatEndTimePOP) {
          // Time switch is ON: use selected time
          endDateTime = `${formatEndDatePOP} ${formatEndTimePOP}`;
        }
        payload.end_date = endDateTime;
      }

      const response = await getSPCReportTableDetails(payload);
      if (response?.data?.success && response?.data?.payload) {
        setReportTableData(response.data.payload);
      } else {
        setReportTableData([]);
      }
    } catch (error) {
      console.error("Error fetching report table data:", error);
      setReportTableData([]);
    } finally {
      setIsLoadingReportTable(false);
    }
  };

  // Transform chart data function (similar to analytics mode)
  const transformChartData = (apiData, isMRChart = false) => {
    if (!apiData || !Array.isArray(apiData)) return [];
    return apiData
      .map((item) => {
        const value = isMRChart
          ? item.tag_value !== null && item.tag_value !== undefined
            ? item.tag_value
            : null
          : item.tag_value !== null && item.tag_value !== undefined
          ? item.tag_value
          : null;

        if (value === null || isNaN(value)) return null;

        const timeKey = item.MIN_KEY || item.created_at;
        const tagTime = timeKey
          ? dayjs(timeKey).format("YYYY-MM-DD HH:mm:ss")
          : "";

        const ruleBreak = item.rule_break || [];
        const isViolation = ruleBreak.length > 0;

        return {
          tagTime: tagTime,
          tagValue: parseFloat(value),
          isViolation: isViolation,
          ruleBreak: ruleBreak,
        };
      })
      .filter((item) => item !== null);
  };

  // Function to fetch chart data for a specific tag
  const fetchChartDataForTag = async (
    tagId,
    tagColor,
    isTag1,
    isMRChart = false,
    useStoredStartDate = false
  ) => {
    if (!tagId || !params || !params.plantid) {
      if (isTag1) {
        setChartDataTag1([]);
        setChartControlLimitsTag1({ ucl: null, cl: null, lcl: null });
      } else {
        setChartDataTag2([]);
        setChartControlLimitsTag2({ ucl: null, cl: null, lcl: null });
      }
      return;
    }

    try {
      const payload = {
        company_id: params.companyid || 0,
        plant_id: params.plantid,
        tag_id: parseInt(tagId),
      };

      // Add interval if available
      const currentInterval =
        activeTabClass === "reports" && selectedReportChartInterval
          ? selectedReportChartInterval
          : smartTagPOPSwitch
          ? LinePOPIntervalTime
          : POPIntervalTimePop;
      if (currentInterval) {
        payload.interval = parseInt(currentInterval);
      }

      // Determine start_date: use date picker or current time
      let startDateTime = null;
      if (formatStartDatePOP) {
        // Check time switch state for Reports mode
        if (activeTabClass === "reports" && !smartTagPOPTime) {
          // Time switch is OFF: use 00:00:00
          startDateTime = `${formatStartDatePOP} 00:00:00`;
        } else if (formatStartTimePOP) {
          // Time switch is ON: use selected time
          startDateTime = `${formatStartDatePOP} ${formatStartTimePOP}`;
        } else {
          // Fallback: use 00:00:00
          startDateTime = `${formatStartDatePOP} 00:00:00`;
        }
      } else {
        // No date selected - use current time
        startDateTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
      }

      if (startDateTime) {
        payload.start_date = startDateTime;
      }

      // Add end_date if date picker has end date
      if (formatEndDatePOP) {
        let endDateTime = formatEndDatePOP;
        // Check time switch state for Reports mode
        if (activeTabClass === "reports" && !smartTagPOPTime) {
          // Time switch is OFF: check if end date is today or past
          const endDateObj = dayjs(formatEndDatePOP);
          const today = dayjs();
          const isToday =
            endDateObj.format("YYYY-MM-DD") === today.format("YYYY-MM-DD");

          if (isToday) {
            // End date is today: use current time
            endDateTime = today.format("YYYY-MM-DD HH:mm:ss");
          } else {
            // End date is past: use 23:59:59
            endDateTime = `${formatEndDatePOP} 23:59:59`;
          }
        } else if (formatEndTimePOP) {
          // Time switch is ON: use selected time
          endDateTime = `${formatEndDatePOP} ${formatEndTimePOP}`;
        } else {
          // Fallback: use 23:59:59
          endDateTime = `${formatEndDatePOP} 23:59:59`;
        }
        payload.end_date = endDateTime;
      }

      const apiFunction = isMRChart
        ? getAnalyticsMRChartDetail
        : getAnalyticsIChartDetail;
      const response = await apiFunction(payload);

      if (response?.data?.success && response?.data?.payload) {
        const transformedData = transformChartData(
          response.data.payload.data || [],
          isMRChart
        );

        if (isTag1) {
          // Always replace data (no polling - one-time API calls)
          setChartDataTag1(transformedData);
          setChartControlLimitsTag1({
            ucl: response.data.payload.ucl_value,
            cl: response.data.payload.cl_value,
            lcl: response.data.payload.lcl_value,
          });
        } else {
          // Always replace data (no polling - one-time API calls)
          setChartDataTag2(transformedData);
          setChartControlLimitsTag2({
            ucl: response.data.payload.ucl_value,
            cl: response.data.payload.cl_value,
            lcl: response.data.payload.lcl_value,
          });
        }
      } else {
        if (isTag1) {
          setChartDataTag1([]);
          setChartControlLimitsTag1({ ucl: null, cl: null, lcl: null });
        } else {
          setChartDataTag2([]);
          setChartControlLimitsTag2({ ucl: null, cl: null, lcl: null });
        }
      }
    } catch (error) {
      console.error(`Error fetching chart data for tag ${tagId}:`, error);
      if (isTag1) {
        setChartDataTag1([]);
        setChartControlLimitsTag1({ ucl: null, cl: null, lcl: null });
      } else {
        setChartDataTag2([]);
        setChartControlLimitsTag2({ ucl: null, cl: null, lcl: null });
      }
    }
  };

  // Effect to fetch chart data when selections, interval, dates, or chart type change
  useEffect(() => {
    // Clear existing intervals
    if (chartTag1IntervalRef.current) {
      clearInterval(chartTag1IntervalRef.current);
      chartTag1IntervalRef.current = null;
    }
    if (chartTag2IntervalRef.current) {
      clearInterval(chartTag2IntervalRef.current);
      chartTag2IntervalRef.current = null;
    }

    if (activeTabClass === "reports" && selectedChartType) {
      setIsLoadingChart(true);
      const isMRChart = selectedChartType === "MR Chart";

      // Get current interval
      const currentInterval =
        activeTabClass === "reports" && selectedReportChartInterval
          ? selectedReportChartInterval
          : smartTagPOPSwitch
          ? LinePOPIntervalTime
          : POPIntervalTimePop;

      // Fetch data for tag 1 if selected (one-time call, no polling)
      if (selectedTag1) {
        const tag1Details = selectedTagDetails.tag1;
        fetchChartDataForTag(
          selectedTag1,
          tag1Details?.color,
          true,
          isMRChart,
          false
        );
      } else {
        setChartDataTag1([]);
        setChartControlLimitsTag1({ ucl: null, cl: null, lcl: null });
      }

      // Fetch data for tag 2 if selected (one-time call, no polling)
      if (selectedTag2) {
        const tag2Details = selectedTagDetails.tag2;
        fetchChartDataForTag(
          selectedTag2,
          tag2Details?.color,
          false,
          isMRChart,
          false
        );
      } else {
        setChartDataTag2([]);
        setChartControlLimitsTag2({ ucl: null, cl: null, lcl: null });
      }

      setIsLoadingChart(false);
    } else {
      setChartDataTag1([]);
      setChartDataTag2([]);
      setChartControlLimitsTag1({ ucl: null, cl: null, lcl: null });
      setChartControlLimitsTag2({ ucl: null, cl: null, lcl: null });
      chartTag1StartDateRef.current = null;
      chartTag2StartDateRef.current = null;
    }

    // Cleanup function
    return () => {
      if (chartTag1IntervalRef.current) {
        clearInterval(chartTag1IntervalRef.current);
        chartTag1IntervalRef.current = null;
      }
      if (chartTag2IntervalRef.current) {
        clearInterval(chartTag2IntervalRef.current);
        chartTag2IntervalRef.current = null;
      }
    };
  }, [
    selectedTag1,
    selectedTag2,
    selectedChartType,
    formatStartDatePOP,
    formatEndDatePOP,
    formatStartTimePOP,
    formatEndTimePOP,
    selectedReportChartInterval,
    POPIntervalTimePop,
    LinePOPIntervalTime,
    smartTagPOPSwitch,
    activeTabClass,
    params?.plantid,
    params?.companyid,
    selectedTagDetails.tag1,
    selectedTagDetails.tag2,
  ]);

  // Expose chart ref to parent component for export functionality
  useEffect(() => {
    if (activeTabClass === "reports" && selectedChartType && onChartRefReady) {
      onChartRefReady(reportsChartRef);
    }
  }, [activeTabClass, selectedChartType, onChartRefReady]);

  // Expose Analytics chart refs to parent component for export functionality
  useEffect(() => {
    if (activeTabClass === "analytics") {
      if (onAnalyticsIChartRefReady) {
        onAnalyticsIChartRefReady(analyticsIChartRef);
      }
      if (onAnalyticsMRChartRefReady) {
        onAnalyticsMRChartRefReady(analyticsMRChartRef);
      }
    }
  }, [activeTabClass, onAnalyticsIChartRefReady, onAnalyticsMRChartRefReady]);

  // Effect to call API when dropdown selections, interval, or dates change
  useEffect(() => {
    if (activeTabClass === "reports") {
      const tagIds = [];

      if (selectedTag1) {
        tagIds.push(parseInt(selectedTag1));
      }
      if (selectedTag2) {
        tagIds.push(parseInt(selectedTag2));
      }

      if (tagIds.length > 0) {
        fetchReportTableData(tagIds);
      } else {
        setReportTableData([]);
      }
    }
  }, [
    selectedTag1,
    selectedTag2,
    formatStartDatePOP,
    formatEndDatePOP,
    formatStartTimePOP,
    formatEndTimePOP,
    POPIntervalTimePop,
    LinePOPIntervalTime,
    smartTagPOPSwitch,
    activeTabClass,
    params?.plantid,
    params?.companyid,
    selectedReportChartInterval,
  ]);

  // Effect to call store API when dropdown tag selections change in reports mode
  useEffect(() => {
    if (
      activeTabClass === "reports" &&
      onDropdownTagChange &&
      (selectedTag1 || selectedTag2)
    ) {
      // Call store API with current dropdown selections
      onDropdownTagChange(selectedTag1 || "", selectedTag2 || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTag1, selectedTag2, activeTabClass, onDropdownTagChange]);

  const dispatch = useDispatch();

  const handleReportData = (e) => {
    if (smartTagPOPSwitch) {
      setLinePOPIntervalTime(e.target.value);
    } else {
      dispatch(
        setSmartTagReportData({
          POPIntervalTimePop: e.target.value,
        })
      );
    }
  };
  const handleReportDataCOC = (e) => {
    if (smartTagCOCSwitch) {
      setLineCOCIntervalTime(e.target.value);
    } else {
      dispatch(
        setSmartTagReportData({
          COCIntervalTime: e.target.value,
        })
      );
    }
  };
  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        md={9}
        className="consumption-table-box bg-white"
      >
        <Box className="consumerData-box">
          {activeTabClass === "analytics" && (
            <div style={{ minHeight: "322px" }}>
              <div className="d-flex justify-content-between">
                <h6>
                  <b>I Chart</b>
                </h6>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {!disableOtherUnits ? (
                    <>
                      <h6 className="AGG-dropdown">Interval</h6>
                      <Box sx={{ minWidth: 200 }} style={{ float: "right" }}>
                        <select
                          className="form-input-class"
                          style={{
                            padding: "14px 8px",
                            borderRadius: "4px",
                            marginRight: "20px",
                          }}
                          id="selectedClass"
                          value={analyticsIChartInterval || "5"}
                          onChange={(e) =>
                            setAnalyticsIChartInterval(e.target.value)
                          }
                          required
                        >
                          {/* <option value="1">1 Min</option> */}
                          <option value="5">5 Min</option>
                          <option value="10">10 Min</option>
                          <option value="15">15 Min</option>
                        </select>
                      </Box>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <SPCSelectedTagGraphData
                ref={analyticsIChartRef}
                graphRealTimeData={
                  analyticsIChartData?.length
                    ? analyticsIChartData
                    : Graphdata || []
                }
                selectTagUnit={analyticsTagName || spcTagUnit || "Tag"}
                tag_hh={
                  analyticsIChartUcl !== null
                    ? analyticsIChartUcl
                    : spcUcl !== undefined
                    ? spcUcl
                    : null
                }
                tag_hi={
                  analyticsIChartCl !== null
                    ? analyticsIChartCl
                    : spcCl !== undefined
                    ? spcCl
                    : null
                }
                tag_ll={
                  analyticsIChartLcl !== null
                    ? analyticsIChartLcl
                    : spcLcl !== undefined
                    ? spcLcl
                    : null
                }
                seriesColor={analyticsTagColor || "#4A90E2"}
                SPC={true}
              />
            </div>
          )}

          {activeTabClass == "analytics" ? (
            <div className="mt-2">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h6>
                  <b>MR Chart</b>
                </h6>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {activeTabClass == "analytics" ? (
                    !disableOtherUnits ? (
                      <>
                        <h6 className="AGG-dropdown">Interval</h6>
                        <Box sx={{ minWidth: 200 }} style={{ float: "right" }}>
                          <select
                            className="form-input-class"
                            style={{
                              padding: "14px 8px",
                              borderRadius: "4px",
                              marginRight: "20px",
                            }}
                            id="selectedClass"
                            value={analyticsMRChartInterval || "5"}
                            onChange={(e) =>
                              setAnalyticsMRChartInterval(e.target.value)
                            }
                            required
                          >
                            {/* <option value="1">1 Min</option> */}
                            <option value="5">5 Min</option>
                            <option value="10">10 Min</option>
                            <option value="15">15 Min</option>
                          </select>
                        </Box>
                      </>
                    ) : (
                      ""
                    )
                  ) : !disableOtherUnitsPOP ? (
                    <>
                      <h6 className="AGG-dropdown">Interval</h6>
                      <Box sx={{ minWidth: 200 }} style={{ float: "right" }}>
                        <select
                          className="form-input-class"
                          style={{
                            padding: "14px 8px",
                            borderRadius: "4px",
                            marginRight: "20px",
                          }}
                          id="selectedClass"
                          value={
                            smartTagPOPSwitch
                              ? LinePOPIntervalTime
                              : POPIntervalTimePop
                          }
                          // value={LinePOPIntervalTime}
                          onChange={(e) => handleReportData(e)}
                          // value={POPIntervalTimePop}
                          // onChange={(e) =>
                          //   dispatch(
                          //     setSmartTagReportData({
                          //       POPIntervalTimePop: e.target.value,
                          //     })
                          //   )
                          // }
                          required
                        >
                          <option value="1" selected disabled hidden>
                            1 min
                          </option>
                          {/* <option value="1">1 Min</option> */}
                          <option value="5">5 Min</option>
                          <option value="10">10 Min</option>
                          <option value="15">15 Min</option>
                        </select>
                      </Box>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              {activeTabClass == "analytics" && (
                <SPCSelectedTagGraphData
                  ref={analyticsMRChartRef}
                  graphRealTimeData={
                    analyticsMRChartData?.length
                      ? analyticsMRChartData
                      : Graphdata || []
                  }
                  selectTagUnit={
                    analyticsTagName ? analyticsTagName : spcTagUnit || "Tag"
                  }
                  tag_hh={
                    analyticsMRChartUcl !== null
                      ? analyticsMRChartUcl
                      : spcUcl !== undefined
                      ? spcUcl
                      : null
                  }
                  tag_hi={
                    analyticsMRChartCl !== null
                      ? analyticsMRChartCl
                      : spcCl !== undefined
                      ? spcCl
                      : null
                  }
                  tag_ll={
                    analyticsMRChartLcl !== null
                      ? analyticsMRChartLcl
                      : spcLcl !== undefined
                      ? spcLcl
                      : null
                  }
                  seriesColor={analyticsTagColor || "#4A90E2"}
                  SPC={true}
                />
              )}
              {activeTabClass == "reports" ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                    gap: "25px",
                    marginLeft: "44px",
                    height: "38px",
                  }}
                ></div>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <div className="mt-2">
              {/* Chart Component for Reports Mode */}
              {activeTabClass === "reports" && selectedChartType && (
                <div className="mt-2" style={{ marginBottom: "20px" }}>
                  <h6>
                    <b>{selectedChartType}</b>
                  </h6>
                  {isLoadingChart ? (
                    <div style={{ padding: "20px", textAlign: "center" }}>
                      Loading chart data...
                    </div>
                  ) : (
                    <div>
                      {/* Single Chart with both tags - always render even if no data */}
                      {
                        <div>
                          <SPCSelectedTagGraphData
                            ref={reportsChartRef}
                            // For single tag (backward compatibility)
                            graphRealTimeData={
                              selectedTag1 && chartDataTag1.length > 0
                                ? chartDataTag1
                                : selectedTag2 && chartDataTag2.length > 0
                                ? chartDataTag2
                                : []
                            }
                            selectTagUnit={
                              selectedTag1
                                ? selectedTagDetails.tag1?.tagName ||
                                  reportsSelectedTags.find(
                                    (t) => t.tagId?.toString() === selectedTag1
                                  )?.tagName ||
                                  ""
                                : selectedTag2
                                ? selectedTagDetails.tag2?.tagName ||
                                  reportsSelectedTags.find(
                                    (t) => t.tagId?.toString() === selectedTag2
                                  )?.tagName ||
                                  ""
                                : ""
                            }
                            tag_hh={
                              selectedTag1
                                ? chartControlLimitsTag1.ucl
                                : chartControlLimitsTag2.ucl
                            }
                            tag_hi={
                              selectedTag1
                                ? chartControlLimitsTag1.cl
                                : chartControlLimitsTag2.cl
                            }
                            tag_ll={
                              selectedTag1
                                ? chartControlLimitsTag1.lcl
                                : chartControlLimitsTag2.lcl
                            }
                            seriesColor={
                              selectedTag1
                                ? selectedTagDetails.tag1?.color || "#4A90E2"
                                : selectedTagDetails.tag2?.color || "#6A5ACD"
                            }
                            // Multiple tags support
                            multipleSeriesData={[
                              ...(selectedTag1 && chartDataTag1.length > 0
                                ? [
                                    {
                                      tagName:
                                        selectedTagDetails.tag1?.tagName ||
                                        reportsSelectedTags.find(
                                          (t) =>
                                            t.tagId?.toString() === selectedTag1
                                        )?.tagName ||
                                        "",
                                      color:
                                        selectedTagDetails.tag1?.color ||
                                        "#4A90E2",
                                      data: chartDataTag1,
                                    },
                                  ]
                                : selectedTag1
                                ? [
                                    {
                                      tagName:
                                        selectedTagDetails.tag1?.tagName ||
                                        reportsSelectedTags.find(
                                          (t) =>
                                            t.tagId?.toString() === selectedTag1
                                        )?.tagName ||
                                        "",
                                      color:
                                        selectedTagDetails.tag1?.color ||
                                        "#4A90E2",
                                      data: [],
                                    },
                                  ]
                                : []),
                              ...(selectedTag2 && chartDataTag2.length > 0
                                ? [
                                    {
                                      tagName:
                                        selectedTagDetails.tag2?.tagName ||
                                        reportsSelectedTags.find(
                                          (t) =>
                                            t.tagId?.toString() === selectedTag2
                                        )?.tagName ||
                                        "",
                                      color:
                                        selectedTagDetails.tag2?.color ||
                                        "#6A5ACD",
                                      data: chartDataTag2,
                                    },
                                  ]
                                : selectedTag2
                                ? [
                                    {
                                      tagName:
                                        selectedTagDetails.tag2?.tagName ||
                                        reportsSelectedTags.find(
                                          (t) =>
                                            t.tagId?.toString() === selectedTag2
                                        )?.tagName ||
                                        "",
                                      color:
                                        selectedTagDetails.tag2?.color ||
                                        "#6A5ACD",
                                      data: [],
                                    },
                                  ]
                                : []),
                            ]}
                            multipleControlLimits={[
                              ...(selectedTag1 ? [chartControlLimitsTag1] : []),
                              ...(selectedTag2 ? [chartControlLimitsTag2] : []),
                            ]}
                          />
                        </div>
                      }
                    </div>
                  )}
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "15px",
                }}
              >
                <Box sx={{ minWidth: 200 }}>
                  <select
                    className="form-input-class"
                    style={{
                      padding: "10px 8px",
                      borderRadius: "4px",
                      width: "100%",
                    }}
                    value={selectedTag1}
                    onChange={(e) => {
                      const tagId = e.target.value;
                      setSelectedTag1(tagId);
                      const selectedTag = reportsSelectedTags.find(
                        (t) => t.tagId?.toString() === tagId
                      );
                      setSelectedTagDetails((prev) => ({
                        ...prev,
                        tag1: selectedTag || null,
                      }));
                      // Call store API when dropdown selection changes
                      if (onDropdownTagChange && activeTabClass === "reports") {
                        onDropdownTagChange(tagId, selectedTag2);
                      }
                    }}
                  >
                    <option value="">Select tag</option>
                    {reportsSelectedTags.map((tag) => (
                      <option key={tag.tagId} value={tag.tagId?.toString()}>
                        {tag.tagName || `Tag ${tag.tagId}`}
                      </option>
                    ))}
                  </select>
                </Box>
                <Box sx={{ minWidth: 200 }}>
                  <select
                    className="form-input-class"
                    style={{
                      padding: "10px 8px",
                      borderRadius: "4px",
                      width: "100%",
                    }}
                    value={selectedTag2}
                    onChange={(e) => {
                      const tagId = e.target.value;
                      setSelectedTag2(tagId);
                      const selectedTag = reportsSelectedTags.find(
                        (t) => t.tagId?.toString() === tagId
                      );
                      setSelectedTagDetails((prev) => ({
                        ...prev,
                        tag2: selectedTag || null,
                      }));
                      // Call store API when dropdown selection changes
                      if (onDropdownTagChange && activeTabClass === "reports") {
                        onDropdownTagChange(selectedTag1, tagId);
                      }
                    }}
                  >
                    <option value="">Select tag</option>
                    {reportsSelectedTags.map((tag) => (
                      <option key={tag.tagId} value={tag.tagId?.toString()}>
                        {tag.tagName || `Tag ${tag.tagId}`}
                      </option>
                    ))}
                  </select>
                </Box>
              </div>

              <div
                style={{
                  overflowX: "auto",
                  overflowY: "auto",
                  maxHeight: "400px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "4px",
                }}
              >
                <Table className="source-table" style={{ minWidth: "100%" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#f5f5f5",
                        }}
                      ></TableCell>
                      {selectedTag1 && (
                        <TableCell
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {reportsSelectedTags.find(
                            (t) => t.tagId?.toString() === selectedTag1
                          )?.tagName || "Tag 1"}
                        </TableCell>
                      )}
                      {selectedTag2 && (
                        <TableCell
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {reportsSelectedTags.find(
                            (t) => t.tagId?.toString() === selectedTag2
                          )?.tagName || "Tag 2"}
                        </TableCell>
                      )}
                      {!selectedTag1 && !selectedTag2 && (
                        <TableCell
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          Select Tag
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ fontWeight: "500" }}>USL</TableCell>
                      {selectedTag1 && (
                        <TableCell>
                          {isLoadingReportTable
                            ? "-"
                            : reportTableData.find(
                                (d) => d.tag_id?.toString() === selectedTag1
                              )?.usl_value ?? "-"}
                        </TableCell>
                      )}
                      {selectedTag2 && (
                        <TableCell>
                          {isLoadingReportTable
                            ? "-"
                            : reportTableData.find(
                                (d) => d.tag_id?.toString() === selectedTag2
                              )?.usl_value ?? "-"}
                        </TableCell>
                      )}
                      {!selectedTag1 && !selectedTag2 && (
                        <TableCell>-</TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "500" }}>LSL</TableCell>
                      {selectedTag1 && (
                        <TableCell>
                          {isLoadingReportTable
                            ? "-"
                            : reportTableData.find(
                                (d) => d.tag_id?.toString() === selectedTag1
                              )?.lsl_value ?? "-"}
                        </TableCell>
                      )}
                      {selectedTag2 && (
                        <TableCell>
                          {isLoadingReportTable
                            ? "-"
                            : reportTableData.find(
                                (d) => d.tag_id?.toString() === selectedTag2
                              )?.lsl_value ?? "-"}
                        </TableCell>
                      )}
                      {!selectedTag1 && !selectedTag2 && (
                        <TableCell>-</TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "500" }}>Mean</TableCell>
                      {selectedTag1 && (
                        <TableCell>
                          {isLoadingReportTable
                            ? "-"
                            : reportTableData.find(
                                (d) => d.tag_id?.toString() === selectedTag1
                              )?.mean_value ?? "-"}
                        </TableCell>
                      )}
                      {selectedTag2 && (
                        <TableCell>
                          {isLoadingReportTable
                            ? "-"
                            : reportTableData.find(
                                (d) => d.tag_id?.toString() === selectedTag2
                              )?.mean_value ?? "-"}
                        </TableCell>
                      )}
                      {!selectedTag1 && !selectedTag2 && (
                        <TableCell>-</TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "500" }}>
                        Std. Dev
                      </TableCell>
                      {selectedTag1 && (
                        <TableCell>
                          {isLoadingReportTable
                            ? "-"
                            : reportTableData.find(
                                (d) => d.tag_id?.toString() === selectedTag1
                              )?.std_dev_value ?? "-"}
                        </TableCell>
                      )}
                      {selectedTag2 && (
                        <TableCell>
                          {isLoadingReportTable
                            ? "-"
                            : reportTableData.find(
                                (d) => d.tag_id?.toString() === selectedTag2
                              )?.std_dev_value ?? "-"}
                        </TableCell>
                      )}
                      {!selectedTag1 && !selectedTag2 && (
                        <TableCell>-</TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "500" }}>CP</TableCell>
                      {selectedTag1 && (
                        <TableCell>
                          {isLoadingReportTable
                            ? "-"
                            : reportTableData.find(
                                (d) => d.tag_id?.toString() === selectedTag1
                              )?.cp_value ?? "-"}
                        </TableCell>
                      )}
                      {selectedTag2 && (
                        <TableCell>
                          {isLoadingReportTable
                            ? "-"
                            : reportTableData.find(
                                (d) => d.tag_id?.toString() === selectedTag2
                              )?.cp_value ?? "-"}
                        </TableCell>
                      )}
                      {!selectedTag1 && !selectedTag2 && (
                        <TableCell>-</TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "500" }}>CPK</TableCell>
                      {selectedTag1 && (
                        <TableCell>
                          {isLoadingReportTable
                            ? "-"
                            : reportTableData.find(
                                (d) => d.tag_id?.toString() === selectedTag1
                              )?.cpk_value ?? "-"}
                        </TableCell>
                      )}
                      {selectedTag2 && (
                        <TableCell>
                          {isLoadingReportTable
                            ? "-"
                            : reportTableData.find(
                                (d) => d.tag_id?.toString() === selectedTag2
                              )?.cpk_value ?? "-"}
                        </TableCell>
                      )}
                      {!selectedTag1 && !selectedTag2 && (
                        <TableCell>-</TableCell>
                      )}
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            </div>
          )}
        </Box>
      </Grid>
    </>
  );
};

export default SPCGraphComponent;